import i18next from "i18next";

enum NotificationChannel {
  Sms,
  Email
}

enum NotificationStatus {
  inProgress,
  Sent,
  Delivered,
  Error,
}

enum NotificationType {
  NewOrders,
  ExpiredOrders,
  NewCompaniesToVerify,
  UsersToVerify,
  ReceptionPlaceToVerify,
  OrderForDriver
}

export const generateSMSHistoryColumns = (isMultiline: boolean) => {
  return [
    {
      key: "sentDate",
      name: i18next.t("nav.sentDate", { ns: "admin" }),
      fieldName: "sentDate",
      minWidth: 80,
      maxWidth: 140,
      isResizable: true,
    },
    {
      key: "status",
      name: i18next.t("nav.status", { ns: "admin" }),
      fieldName: "status",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "channel",
      name: i18next.t("nav.channelLabel", { ns: "admin" }),
      fieldName: "channel",
      minWidth: 40,
      maxWidth: 80,
    },
    {
      key: "type",
      name: i18next.t("nav.typeLabel", { ns: "admin" }),
      fieldName: "type",
      minWidth: 70,
      maxWidth: 140,
      isResizable: true,
    },
    {
      key: "body",
      name: i18next.t("nav.bodyLabel", { ns: "admin" }),
      fieldName: "body",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      isMultiline: isMultiline
    },

  ];
};

export const generateSMSHistory = (Item: any) => {
  const items: Array<any> = [];
  Item.forEach((Item: any) => {
    items.push({
      key: Item.id,
      id: Item.id,
      body: Item.body,
      channel: parseNotificationChannel(Item.channel),
      status: parseNotificationStatus(Item.status),
      type: parseNotificationType(Item.type),
      sentDate: new Date(Item.sentDate).toISOString().replace(/\.\d+/, "").replace(/T|Z/g, ' '),
    });
  });

  return [...items];
};

const parseNotificationChannel = (key: any) => {
  switch (key) {
    case NotificationChannel.Sms: {
      return i18next.t("nav.sms", { ns: "admin" });
    }
    case NotificationChannel.Email: {
      return i18next.t("nav.email", { ns: "admin" });
    }
    default: {
      return i18next.t("nav.unknown", { ns: "admin" });
    }
  }
}

const parseNotificationStatus = (key: any) => {
  switch (key) {
    case NotificationStatus.inProgress: {
      return i18next.t("nav.inProgress", { ns: "admin" });
    }
    case NotificationStatus.Sent: {
      return i18next.t("nav.sent", { ns: "admin" });
    }
    case NotificationStatus.Delivered: {
      return i18next.t("nav.delivered", { ns: "admin" });
    }
    case NotificationStatus.Error: {
      return i18next.t("nav.error", { ns: "admin" });
    }
    default: {
      return i18next.t("nav.unknown", { ns: "admin" });
    }
  }
}

const parseNotificationType = (key: any) => {
  switch (key) {
    case NotificationType.NewOrders: {
      return i18next.t("nav.newOrders", { ns: "admin" });
    }
    case NotificationType.ExpiredOrders: {
      return i18next.t("nav.overdueOrders", { ns: "admin" });
    }
    case NotificationType.NewCompaniesToVerify: {
      return i18next.t("nav.newCompaniesToVerify", { ns: "admin" });
    }
    case NotificationType.UsersToVerify: {
      return i18next.t("nav.usersToVerify", { ns: "admin" });
    }
    case NotificationType.ReceptionPlaceToVerify: {
      return i18next.t("nav.receptionPlaceToVerify", { ns: "admin" });
    }
    case NotificationType.OrderForDriver: {
      return i18next.t("nav.orderForDriver", { ns: "admin" });
    }
    default: {
      return i18next.t("nav.unknown", { ns: "admin" });
    }
  }
}